/* JMT optional fit-adjustment sync.
   Global preferences sync with PDP/sticky controls only. Cart-line edits are
   deliberately isolated inside the shared Fit Builder. */
(function () {
  'use strict';

  var EVT = 'jmt:pref:change';
  var applying = false;
  var observer = null;
  var retryCount = 0;

  function prefApi() {
    return window.JMT_PREF &&
      typeof window.JMT_PREF.get === 'function' &&
      typeof window.JMT_PREF.set === 'function'
      ? window.JMT_PREF
      : null;
  }

  function adjustmentKey(control) {
    if (!control) return '';
    var explicit =
      control.getAttribute('data-jmt-product-adjustment') ||
      control.getAttribute('data-jmt-adjustment');
    if (explicit) return explicit;
    if (control.id === 'jmt-prefbar-pouch-adjustment' || control.classList.contains('jmt-prop-pouch')) {
      return 'pouchAdjustment';
    }
    if (control.id === 'jmt-prefbar-back-adjustment' || control.classList.contains('jmt-prop-strap')) {
      return 'backStrapAdjustment';
    }
    return '';
  }

  function sharedControls(root) {
    root = root || document;
    return Array.from(root.querySelectorAll([
      '[data-jmt-product-adjustment]',
      '[data-jmt-adjustment]',
      '#jmt-prefbar-pouch-adjustment',
      '#jmt-prefbar-back-adjustment'
    ].join(',')));
  }

  function apply(pref, root) {
    applying = true;
    sharedControls(root).forEach(function (control) {
      var key = adjustmentKey(control);
      var value = pref && key ? String(pref[key] || '') : '';
      if (control.value !== value) control.value = value;
      if (control.hasAttribute('data-jmt-adjustment-labels')) {
        setAdjustmentLabelMode(control, false);
      }
    });
    applying = false;
    syncProductAdjustmentDisclosure(root);
    syncSelectedAdjustmentSummaries(root);
  }

  function adjustmentText(value) {
    value = String(value || '').trim();
    if (!value || /^(?:none|no adjustments?)$/i.test(value)) return 'No adjustment';
    if (/^[+-]?\d+$/.test(value)) return value + (Math.abs(Number(value)) === 1 ? ' inch' : ' inches');
    return value;
  }

  function syncSelectedAdjustmentSummaries(root) {
    (root || document).querySelectorAll('.jmt-product-adjustments [data-jmt-selected-adjustments]').forEach(function (summary) {
      var container = summary.closest('.jmt-product-adjustments');
      if (!container) return;
      var pouch = container.querySelector('[data-jmt-product-adjustment="pouchAdjustment"]');
      var back = container.querySelector('[data-jmt-product-adjustment="backStrapAdjustment"]');
      var pouchValue = pouch ? String(pouch.value || '').trim() : '';
      var backValue = back ? String(back.value || '').trim() : '';
      summary.hidden = !pouchValue && !backValue;
      summary.querySelector('[data-jmt-selected-adjustment="pouchAdjustment"]').textContent = 'Pouch depth: ' + adjustmentText(pouchValue);
      summary.querySelector('[data-jmt-selected-adjustment="backStrapAdjustment"]').textContent = 'Back-strap length: ' + adjustmentText(backValue);
    });
  }

  function syncProductAdjustmentDisclosure(root) {
    (root || document).querySelectorAll('[data-jmt-adjustment-toggle]').forEach(function (button) {
      var container = button.closest('.jmt-product-adjustments');
      var panelId = button.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!container || !panel) return;
      if (button.dataset.jmtAdjustmentDisclosureTouched === 'true') return;
      var hasSelection = Array.from(container.querySelectorAll('[data-jmt-product-adjustment]')).some(function (control) {
        var value = String(control.value || '').trim().toLowerCase();
        return Boolean(value && value !== 'none' && value !== 'no adjustment' && value !== 'no adjustments');
      });
      if (container.matches('details[data-jmt-adjustment-disclosure]')) {
        container.open = hasSelection;
      } else {
        panel.hidden = !hasSelection;
      }
      button.setAttribute('aria-expanded', hasSelection ? 'true' : 'false');
    });
  }

  function writeControlToPreference(control) {
    if (applying) return;
    var key = adjustmentKey(control);
    if (!key) return;
    var quickFit = document.getElementById('jmt-quick-fit');
    if (control.closest('[data-jmt-adjustment-modal][data-jmt-quick-fit-context]') && quickFit && !quickFit.hidden) {
      var stagedField = quickFit.querySelector('[data-jmt-quick-fit-field="' + key + '"]');
      if (stagedField) stagedField.value = control.value;
      return;
    }
    var api = prefApi();
    if (!api) return;
    var patch = {};
    patch[key] = control.value;
    api.set(patch);
  }

  function bindSharedControl(control) {
    if (!control || control.__jmtUnifiedAdjustmentBound) return;
    control.__jmtUnifiedAdjustmentBound = true;
    control.addEventListener('change', function () {
      writeControlToPreference(control);
    });
  }

  function bindToggles(root) {
    (root || document).querySelectorAll('[data-jmt-adjustment-toggle]').forEach(function (button) {
      if (button.__jmtAdjustmentToggleBound) return;
      var panelId = button.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;
      var disclosure = button.closest('details[data-jmt-adjustment-disclosure]');
      if (disclosure) {
        button.__jmtAdjustmentToggleBound = true;
        button.setAttribute('aria-expanded', disclosure.open ? 'true' : 'false');
        button.addEventListener('click', function () {
          button.dataset.jmtAdjustmentDisclosureTouched = 'true';
        });
        disclosure.addEventListener('toggle', function () {
          button.setAttribute('aria-expanded', disclosure.open ? 'true' : 'false');
        });
        return;
      }
      panel.hidden = button.getAttribute('aria-expanded') !== 'true';
      button.__jmtAdjustmentToggleBound = true;
      button.addEventListener('click', function () {
        button.dataset.jmtAdjustmentDisclosureTouched = 'true';
        var opening = panel.hidden;
        panel.hidden = !opening;
        button.setAttribute('aria-expanded', opening ? 'true' : 'false');
      });
    });
  }

  function setAdjustmentLabelMode(select, showFullLabels) {
    Array.from(select.options || []).forEach(function (option) {
      var fullLabel = option.getAttribute('data-full') || option.textContent;
      var shortLabel = option.getAttribute('data-short') || fullLabel;
      option.textContent = (!showFullLabels && option.selected) ? shortLabel : fullLabel;
    });
  }

  function bindAdjustmentLabels(root) {
    (root || document).querySelectorAll('select[data-jmt-adjustment-labels]').forEach(function (select) {
      if (select.__jmtAdjustmentLabelsBound) return;
      select.__jmtAdjustmentLabelsBound = true;
      setAdjustmentLabelMode(select, false);
      select.addEventListener('focus', function () { setAdjustmentLabelMode(select, true); });
      select.addEventListener('pointerdown', function () { setAdjustmentLabelMode(select, true); });
      select.addEventListener('blur', function () { setAdjustmentLabelMode(select, false); });
      select.addEventListener('change', function () {
        window.setTimeout(function () { setAdjustmentLabelMode(select, false); }, 0);
      });
    });
  }

  function bindAll(root) {
    sharedControls(root).forEach(bindSharedControl);
    bindToggles(root);
    bindAdjustmentLabels(root);
  }

  function hydrate(root) {
    var api = prefApi();
    if (!api) return false;
    EVT = api.EVT || EVT;
    bindAll(root);
    apply(api.get() || {}, root);
    return true;
  }

  function start() {
    bindAll(document);
    if (!hydrate(document) && retryCount < 40) {
      retryCount += 1;
      window.setTimeout(start, 50);
      return;
    }

    if (!observer && window.MutationObserver) {
      observer = new MutationObserver(function (mutations) {
        var api = prefApi();
        mutations.forEach(function (mutation) {
          Array.from(mutation.addedNodes || []).forEach(function (node) {
            if (!node || node.nodeType !== 1) return;
            bindAll(node);
            if (api) apply(api.get() || {}, node);
          });
        });
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start)
    : start();

  window.addEventListener(EVT, function (event) {
    var api = prefApi();
    var pref = event && event.detail ? event.detail : (api ? api.get() || {} : {});
    apply(pref, document);
  });

  window.addEventListener('pageshow', function () {
    hydrate(document);
  });
})();
